import React, { useEffect, useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import API_BASE_URL from "../apiBase";

function Sidebar({ active, onChange }) {
  return (
    <div
      style={{
        width: "260px",
        backgroundColor: "#111827",
        color: "#e5e7eb",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "100vh",
        padding: "16px",
      }}
    >
      <div>
        <div style={{ marginBottom: "32px" }}>
          <h4 style={{ color: "#f9fafb", margin: 0 }}>Green Circle Admin</h4>
          <p style={{ color: "#9ca3af", fontSize: "12px", marginTop: "4px" }}>
            Welcome, Admin
          </p>
        </div>
        <div style={{ marginBottom: "16px" }}>
          <p
            style={{
              textTransform: "uppercase",
              fontSize: "11px",
              color: "#6b7280",
              marginBottom: "8px",
            }}
          >
            Blogs
          </p>
          <button
            type="button"
            onClick={() => onChange("add")}
            style={{
              width: "100%",
              textAlign: "left",
              border: "none",
              borderRadius: "6px",
              padding: "8px 12px",
              marginBottom: "6px",
              backgroundColor:
                active === "add" ? "rgba(59,130,246,0.15)" : "transparent",
              color: active === "add" ? "#ffffff" : "#e5e7eb",
              cursor: "pointer",
            }}
          >
            Add Blog
          </button>
          <button
            type="button"
            onClick={() => onChange("view")}
            style={{
              width: "100%",
              textAlign: "left",
              border: "none",
              borderRadius: "6px",
              padding: "8px 12px",
              marginBottom: "6px",
              backgroundColor:
                active === "view" ? "rgba(59,130,246,0.15)" : "transparent",
              color: active === "view" ? "#ffffff" : "#e5e7eb",
              cursor: "pointer",
            }}
          >
            View Blogs
          </button>
        </div>
        <div style={{ marginBottom: "16px" }}>
          <p
            style={{
              textTransform: "uppercase",
              fontSize: "11px",
              color: "#6b7280",
              marginBottom: "8px",
            }}
          >
            SEO
          </p>
          <button
            type="button"
            onClick={() => onChange("seo")}
            style={{
              width: "100%",
              textAlign: "left",
              border: "none",
              borderRadius: "6px",
              padding: "8px 12px",
              marginBottom: "6px",
              backgroundColor:
                active === "seo" ? "rgba(59,130,246,0.15)" : "transparent",
              color: active === "seo" ? "#ffffff" : "#e5e7eb",
              cursor: "pointer",
            }}
          >
            SEO Management
          </button>
          <button
            type="button"
            onClick={() => onChange("seoFiles")}
            style={{
              width: "100%",
              textAlign: "left",
              border: "none",
              borderRadius: "6px",
              padding: "8px 12px",
              marginBottom: "6px",
              backgroundColor:
                active === "seoFiles" ? "rgba(59,130,246,0.15)" : "transparent",
              color: active === "seoFiles" ? "#ffffff" : "#e5e7eb",
              cursor: "pointer",
            }}
          >
            SEO Files
          </button>
        </div>
        <div style={{ marginBottom: "16px" }}>
          <p
            style={{
              textTransform: "uppercase",
              fontSize: "11px",
              color: "#6b7280",
              marginBottom: "8px",
            }}
          >
            Settings
          </p>
          <button
            type="button"
            onClick={() => onChange("analytics")}
            style={{
              width: "100%",
              textAlign: "left",
              border: "none",
              borderRadius: "6px",
              padding: "8px 12px",
              marginBottom: "6px",
              backgroundColor:
                active === "analytics" ? "rgba(59,130,246,0.15)" : "transparent",
              color: active === "analytics" ? "#ffffff" : "#e5e7eb",
              cursor: "pointer",
            }}
          >
            GA4 Settings
          </button>
        </div>
      </div>
      <button
        type="button"
        onClick={async () => {
          try {
            await fetch(`${API_BASE_URL}/admin/logout.php`, {
              method: "POST",
              credentials: "include",
            });
          } finally {
            window.location.href = "/admin/login";
          }
        }}
        style={{
          width: "100%",
          border: "none",
          borderRadius: "6px",
          padding: "10px 12px",
          backgroundColor: "#ef4444",
          color: "#f9fafb",
          fontWeight: 500,
          cursor: "pointer",
        }}
      >
        Logout
      </button>
    </div>
  );
}

function AddBlog({ onCreated }) {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const editorRef = useRef(null);
  const contentImageInputRef = useRef(null);

  const focusEditor = () => {
    if (editorRef.current) {
      editorRef.current.focus();
    }
  };

  const applyFormat = (command, value = null) => {
    focusEditor();
    document.execCommand(command, false, value);
    if (editorRef.current) {
      setContent(editorRef.current.innerHTML);
    }
  };

  const handleEditorInput = () => {
    if (editorRef.current) {
      setContent(editorRef.current.innerHTML);
    }
  };

  const handleCreateLink = () => {
    const url = window.prompt("Enter URL");
    if (url) {
      applyFormat("createLink", url);
    }
  };

  const handleInsertImage = () => {
    const url = window.prompt("Enter image URL");
    if (url) {
      applyFormat("insertImage", url);
    }
  };

  const handleInsertContentImage = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const base64Image = event.target?.result;
        if (base64Image) {
          applyFormat("insertImage", base64Image);
        }
      };
      reader.readAsDataURL(file);
    }
    // Reset input so same file can be selected again
    if (contentImageInputRef.current) {
      contentImageInputRef.current.value = "";
    }
  };

  const handleFormatBlock = (block) => {
    if (block) {
      applyFormat("formatBlock", block);
    }
  };

  const handleClearContent = () => {
    if (editorRef.current) {
      editorRef.current.innerHTML = "";
    }
    setContent("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    if (!title || !content) {
      setError("Blog title and content are required.");
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("description", content);
      if (image) {
        formData.append("image", image);
      }

      const res = await fetch(`${API_BASE_URL}/admin/add_blog.php`, {
        method: "POST",
        body: formData,
      });
      
      const rawText = await res.text();
      let data;
      try {
        data = JSON.parse(rawText);
      } catch (parseErr) {
        throw new Error(`Server returned invalid response: ${rawText.substring(0, 200)}`);
      }
      
      if (!res.ok) {
        throw new Error(data.error || `Server error (${res.status}): ${rawText.substring(0, 200)}`);
      }
      
      if (data.success) {
        setMessage("Blog created successfully.");
        setTitle("");
        setContent("");
        setImage(null);
        if (editorRef.current) {
          editorRef.current.innerHTML = "";
        }
        if (onCreated) onCreated();
      } else {
        setError(data.error || "Failed to create blog.");
      }
    } catch (err) {
      console.error("Add blog error:", err);
      console.error("API URL attempted:", `${API_BASE_URL}/admin/add_blog.php`);
      setError(err.message || "Unable to connect to server. Please check your connection.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid py-4">
      <h3 className="mb-3">Add Blog</h3>
      <form onSubmit={handleSubmit} className="bg-white p-4 rounded shadow-sm">
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        {message && (
          <div className="alert alert-success" role="alert">
            {message}
          </div>
        )}
        <div className="mb-3">
          <label className="form-label">Blog Title</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Blog Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Content</label>
          <div className="d-flex flex-wrap gap-2 align-items-center mb-2">
            <div className="btn-group btn-group-sm" role="group">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("undo")}
              >
                Undo
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("redo")}
              >
                Redo
              </button>
            </div>
            <div className="btn-group btn-group-sm" role="group">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("bold")}
              >
                <strong>B</strong>
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("italic")}
              >
                <em>I</em>
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("underline")}
              >
                <u>U</u>
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("strikeThrough")}
              >
                <s>S</s>
              </button>
            </div>
            <select
              className="form-select form-select-sm w-auto"
              defaultValue=""
              onChange={(e) => {
                handleFormatBlock(e.target.value);
                e.target.value = "";
              }}
            >
              <option value="">Style</option>
              <option value="p">Paragraph</option>
              <option value="h1">Heading 1</option>
              <option value="h2">Heading 2</option>
              <option value="h3">Heading 3</option>
              <option value="blockquote">Quote</option>
              <option value="pre">Code</option>
            </select>
            <div className="btn-group btn-group-sm" role="group">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("justifyLeft")}
              >
                Align L
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("justifyCenter")}
              >
                Align C
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("justifyRight")}
              >
                Align R
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("justifyFull")}
              >
                Justify
              </button>
            </div>
            <div className="btn-group btn-group-sm" role="group">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("insertUnorderedList")}
              >
                Bullets
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("insertOrderedList")}
              >
                Numbers
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("outdent")}
              >
                Outdent
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("indent")}
              >
                Indent
              </button>
            </div>
            <div className="btn-group btn-group-sm" role="group">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={handleCreateLink}
              >
                Link
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("unlink")}
              >
                Unlink
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={handleInsertImage}
              >
                Image URL
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => contentImageInputRef.current?.click()}
                title="Upload image from file"
              >
                Upload Image
              </button>
              <input
                ref={contentImageInputRef}
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleInsertContentImage}
              />
            </div>
            <div className="btn-group btn-group-sm" role="group">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("superscript")}
              >
                X²
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("subscript")}
              >
                X₂
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("insertHorizontalRule")}
              >
                HR
              </button>
            </div>
            <div className="d-flex align-items-center gap-2">
              <label className="d-flex align-items-center gap-1 mb-0 small">
                <span>Text</span>
                <input
                  type="color"
                  className="form-control form-control-color p-0"
                  onChange={(e) => applyFormat("foreColor", e.target.value)}
                  title="Text color"
                />
              </label>
              <label className="d-flex align-items-center gap-1 mb-0 small">
                <span>Fill</span>
                <input
                  type="color"
                  className="form-control form-control-color p-0"
                  onChange={(e) => applyFormat("hiliteColor", e.target.value)}
                  title="Highlight color"
                />
              </label>
            </div>
            <div className="btn-group btn-group-sm" role="group">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => applyFormat("removeFormat")}
              >
                Clear fmt
              </button>
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={handleClearContent}
              >
                Reset
              </button>
            </div>
          </div>
          <div
            ref={editorRef}
            contentEditable
            className="form-control"
            style={{ minHeight: "200px", overflowY: "auto" }}
            onInput={handleEditorInput}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Upload Image (Optional)</label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={(e) => setImage(e.target.files[0] || null)}
          />
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>
    </div>
  );
}

function ViewBlogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchBlogs = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_BASE_URL}/admin/list_blogs.php`);
      const rawText = await res.text();
      
      // Handle empty response
      if (!rawText || rawText.trim() === '') {
        throw new Error('Server returned empty response. Please check if the API endpoint is accessible.');
      }
      
      let data;
      try {
        data = JSON.parse(rawText);
      } catch (parseErr) {
        throw new Error(`Invalid blog response: ${rawText.substring(0, 200)}`);
      }
      
      if (!res.ok) {
        throw new Error(data.error || `Server error (${res.status})`);
      }
      
      if (data.success) {
        setBlogs(data.blogs || []);
      } else {
        setError(data.error || "Failed to load blogs.");
        setBlogs([]);
      }
    } catch (err) {
      console.error("Fetch blogs error:", err);
      console.error("API URL attempted:", `${API_BASE_URL}/admin/list_blogs.php`);
      setError(err.message || "Unable to connect to server. Please check your connection.");
      setBlogs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this blog?"
    );
    if (!confirmDelete) return;
    try {
      const res = await fetch(`${API_BASE_URL}/admin/delete_blog.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      const data = await res.json();
      if (data.success) {
        setBlogs((prev) => prev.filter((b) => b.id !== id));
      } else {
        alert(data.error || "Failed to delete blog.");
      }
    } catch (err) {
      console.error("Delete blog error:", err);
      console.error("API URL attempted:", `${API_BASE_URL}/admin/delete_blog.php`);
      alert(`Unable to connect to server. ${err.message || "Please check your connection."}`);
    }
  };

  const stripHtml = (html) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html || "";
    return tmp.textContent || tmp.innerText || "";
  };

  return (
    <div className="container-fluid py-4">
      <h3 className="mb-3">Blogs</h3>
      <div className="bg-white p-3 rounded shadow-sm">
        {loading && <p>Loading blogs...</p>}
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        {!loading && blogs.length === 0 && (
          <p className="mb-0 text-center">No blogs found.</p>
        )}
        {blogs.length > 0 && (
          <div className="table-responsive">
            <table className="table table-striped align-middle">
              <thead className="table-dark">
                <tr>
                  <th style={{ width: "60px" }}>#</th>
                  <th style={{ width: "220px" }}>Blog Title</th>
                  <th>Content</th>
                  <th style={{ width: "140px" }}>Image</th>
                  <th style={{ width: "120px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {blogs.map((blog, idx) => (
                  <tr key={blog.id}>
                    <td>{idx + 1}</td>
                    <td>{blog.title}</td>
                    <td style={{ maxWidth: "420px" }}>
                      {stripHtml(blog.description).slice(0, 160)}
                      {stripHtml(blog.description).length > 160 && "..."}
                    </td>
                    <td>
                      {blog.image_url ? (
                        <img
                          src={blog.image_url}
                          alt={blog.title}
                          style={{
                            maxHeight: "60px",
                            borderRadius: "4px",
                          }}
                        />
                      ) : (
                        <span className="text-muted">No image</span>
                      )}
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleDelete(blog.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

function SeoManagement() {
  const [pages, setPages] = useState([]);
  const [expandedPage, setExpandedPage] = useState("");
  const [loading, setLoading] = useState(false);
  const [savingKey, setSavingKey] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const fetchSeoPages = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_BASE_URL}/admin/list_seo.php`);
      const rawText = await res.text();
      let data;
      try {
        data = JSON.parse(rawText);
      } catch {
        throw new Error(`Invalid SEO response: ${rawText.substring(0, 200)}`);
      }

      if (!res.ok || !data.success) {
        throw new Error(data.error || "Failed to load SEO pages.");
      }

      setPages(data.pages || []);
      setExpandedPage((current) => current || data.pages?.[0]?.page_key || "");
    } catch (err) {
      console.error("Fetch SEO error:", err);
      setError(err.message || "Unable to load SEO metadata.");
      setPages([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSeoPages();
  }, []);

  const updatePageField = (pageKey, field, value) => {
    setPages((prev) =>
      prev.map((page) =>
        page.page_key === pageKey ? { ...page, [field]: value } : page
      )
    );
  };

  const savePage = async (page) => {
    setSavingKey(page.page_key);
    setMessage("");
    setError("");
    try {
      const res = await fetch(`${API_BASE_URL}/admin/save_seo.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          page_key: page.page_key,
          page_label: page.page_label,
          page_path: page.page_path,
          meta_title: page.meta_title || "",
          meta_description: page.meta_description || "",
          meta_keywords: page.meta_keywords || "",
        }),
      });
      const rawText = await res.text();
      let data;
      try {
        data = JSON.parse(rawText);
      } catch {
        throw new Error(`Invalid save response: ${rawText.substring(0, 200)}`);
      }

      if (!res.ok || !data.success) {
        throw new Error(data.error || "Failed to save SEO metadata.");
      }

      setMessage(`${page.page_label} SEO metadata saved successfully.`);
    } catch (err) {
      console.error("Save SEO error:", err);
      setError(err.message || "Unable to save SEO metadata.");
    } finally {
      setSavingKey("");
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h3 className="mb-1">SEO Management</h3>
          <p className="text-muted mb-0">
            Manage meta title, meta description, and keywords for frontend pages.
          </p>
        </div>
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={fetchSeoPages}
          disabled={loading}
        >
          Refresh
        </button>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}
      {message && (
        <div className="alert alert-success" role="alert">
          {message}
        </div>
      )}

      {loading && <p>Loading SEO pages...</p>}

      {!loading && (
        <div className="accordion">
          {pages.map((page, index) => (
            <div className="accordion-item" key={page.page_key}>
              <h2 className="accordion-header" id={`heading-${page.page_key}`}>
                <button
                  className={`accordion-button ${
                    expandedPage === page.page_key ? "" : "collapsed"
                  }`}
                  type="button"
                  onClick={() =>
                    setExpandedPage((current) =>
                      current === page.page_key ? "" : page.page_key
                    )
                  }
                  aria-expanded={expandedPage === page.page_key ? "true" : "false"}
                  aria-controls={`collapse-${page.page_key}`}
                >
                  <span className="fw-semibold">{page.page_label}</span>
                  <span className="ms-2 text-muted small">{page.page_path}</span>
                </button>
              </h2>
              <div
                id={`collapse-${page.page_key}`}
                className={`accordion-collapse collapse ${
                  expandedPage === page.page_key ? "show" : ""
                }`}
                aria-labelledby={`heading-${page.page_key}`}
              >
                <div className="accordion-body bg-white">
                  <div className="mb-3">
                    <label className="form-label">Meta Title</label>
                    <input
                      type="text"
                      className="form-control"
                      value={page.meta_title || ""}
                      maxLength={255}
                      onChange={(e) =>
                        updatePageField(page.page_key, "meta_title", e.target.value)
                      }
                      placeholder={`${page.page_label} | Green Circle Environment`}
                    />
                    <div className="form-text">
                      {(page.meta_title || "").length}/255 characters
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Meta Description</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={page.meta_description || ""}
                      onChange={(e) =>
                        updatePageField(
                          page.page_key,
                          "meta_description",
                          e.target.value
                        )
                      }
                      placeholder="Write a clear search result description for this page."
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Keywords</label>
                    <textarea
                      className="form-control"
                      rows="2"
                      value={page.meta_keywords || ""}
                      onChange={(e) =>
                        updatePageField(page.page_key, "meta_keywords", e.target.value)
                      }
                      placeholder="waste management, green circle, environment services"
                    />
                    <div className="form-text">
                      Separate keywords with commas.
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => savePage(page)}
                    disabled={savingKey === page.page_key}
                  >
                    {savingKey === page.page_key ? "Saving..." : "Save SEO"}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function AnalyticsSettings() {
  const [measurementId, setMeasurementId] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const fetchSettings = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_BASE_URL}/admin/get_analytics_settings.php`);
      const rawText = await res.text();
      let data;
      try {
        data = JSON.parse(rawText);
      } catch {
        throw new Error(`Invalid settings response: ${rawText.substring(0, 200)}`);
      }

      if (!res.ok || !data.success) {
        throw new Error(data.error || "Failed to load analytics settings.");
      }

      setMeasurementId(data.measurement_id || "");
    } catch (err) {
      console.error("Fetch analytics settings error:", err);
      setError(err.message || "Unable to load analytics settings.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const saveSettings = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage("");
    setError("");

    const normalizedMeasurementId = measurementId.trim().toUpperCase();

    try {
      const res = await fetch(`${API_BASE_URL}/admin/save_analytics_settings.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ measurement_id: normalizedMeasurementId }),
      });
      const rawText = await res.text();
      let data;
      try {
        data = JSON.parse(rawText);
      } catch {
        throw new Error(`Invalid save response: ${rawText.substring(0, 200)}`);
      }

      if (!res.ok || !data.success) {
        throw new Error(data.error || "Failed to save analytics settings.");
      }

      setMeasurementId(data.measurement_id || "");
      setMessage(
        data.enabled
          ? "Google Analytics is enabled for the website."
          : "Google Analytics is disabled."
      );
    } catch (err) {
      console.error("Save analytics settings error:", err);
      setError(err.message || "Unable to save analytics settings.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h3 className="mb-1">GA4 Settings</h3>
          <p className="text-muted mb-0">
            Add a Google Analytics Measurement ID to enable sitewide tracking.
          </p>
        </div>
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={fetchSettings}
          disabled={loading}
        >
          Refresh
        </button>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}
      {message && (
        <div className="alert alert-success" role="alert">
          {message}
        </div>
      )}

      <form onSubmit={saveSettings} className="bg-white p-4 rounded shadow-sm">
        <div className="mb-3">
          <label className="form-label">Google Analytics Measurement ID</label>
          <input
            type="text"
            className="form-control"
            value={measurementId}
            maxLength={22}
            onChange={(e) => setMeasurementId(e.target.value)}
            placeholder="G-XXXXXXXXXX"
            disabled={loading || saving}
            autoCapitalize="characters"
            spellCheck="false"
          />
          <div className="form-text">
            Leave this field empty and save to disable Google Analytics.
          </div>
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading || saving}>
          {saving ? "Saving..." : "Save"}
        </button>
      </form>
    </div>
  );
}

function SeoFiles() {
  const [robots, setRobots] = useState("");
  const [sitemap, setSitemap] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const fetchFiles = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_BASE_URL}/admin/seo_files.php`, {
        credentials: "include",
      });
      const rawText = await res.text();
      let data;
      try {
        data = JSON.parse(rawText);
      } catch {
        throw new Error(`Invalid SEO files response: ${rawText.substring(0, 200)}`);
      }

      if (!res.ok || !data.success) {
        throw new Error(data.error || "Failed to load SEO files.");
      }

      setRobots(data.robots || "");
      setSitemap(data.sitemap || "");
    } catch (err) {
      console.error("Fetch SEO files error:", err);
      setError(err.message || "Unable to load SEO files.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  const uploadTextFile = (event, setter, expectedExtension) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    setMessage("");
    setError("");

    if (!file) return;

    const lowerName = file.name.toLowerCase();
    if (!lowerName.endsWith(expectedExtension)) {
      setError(`Please upload a ${expectedExtension} file.`);
      return;
    }

    if (file.size > 1024 * 1024) {
      setError("Uploaded SEO files must be 1 MB or smaller.");
      return;
    }

    const reader = new FileReader();
    reader.onload = () => setter(String(reader.result || ""));
    reader.onerror = () => setError("Unable to read the uploaded file.");
    reader.readAsText(file);
  };

  const validateSitemapInBrowser = () => {
    const trimmed = sitemap.trim();
    if (!trimmed) {
      return "sitemap.xml cannot be empty.";
    }
    const doc = new DOMParser().parseFromString(trimmed, "application/xml");
    const parserError = doc.querySelector("parsererror");
    if (parserError) {
      return parserError.textContent || "Invalid sitemap XML.";
    }
    const root = doc.documentElement?.localName?.toLowerCase();
    if (root !== "urlset" && root !== "sitemapindex") {
      return "sitemap.xml root element must be urlset or sitemapindex.";
    }
    return "";
  };

  const saveFiles = async (event) => {
    event.preventDefault();
    setSaving(true);
    setMessage("");
    setError("");

    const xmlError = validateSitemapInBrowser();
    if (xmlError) {
      setError(xmlError);
      setSaving(false);
      return;
    }

    try {
      const res = await fetch(`${API_BASE_URL}/admin/seo_files.php`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ robots, sitemap }),
      });
      const rawText = await res.text();
      let data;
      try {
        data = JSON.parse(rawText);
      } catch {
        throw new Error(`Invalid save response: ${rawText.substring(0, 200)}`);
      }

      if (!res.ok || !data.success) {
        throw new Error(data.error || "Failed to save SEO files.");
      }

      setMessage(data.message || "SEO files saved successfully.");
    } catch (err) {
      console.error("Save SEO files error:", err);
      setError(err.message || "Unable to save SEO files.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h3 className="mb-1">SEO Files</h3>
          <p className="text-muted mb-0">
            Edit and publish the root robots.txt and sitemap.xml files.
          </p>
        </div>
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={fetchFiles}
          disabled={loading || saving}
        >
          Refresh
        </button>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}
      {message && (
        <div className="alert alert-success" role="alert">
          {message}{" "}
          <a href="/robots.txt" target="_blank" rel="noreferrer">
            robots.txt
          </a>{" "}
          <span className="text-muted">|</span>{" "}
          <a href="/sitemap.xml" target="_blank" rel="noreferrer">
            sitemap.xml
          </a>
        </div>
      )}

      <form onSubmit={saveFiles}>
        <div className="row g-3">
          <div className="col-lg-6">
            <div className="bg-white p-3 rounded shadow-sm h-100">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <label className="form-label fw-semibold mb-0">robots.txt</label>
                <label className="btn btn-sm btn-outline-secondary mb-0">
                  Upload
                  <input
                    type="file"
                    accept=".txt,text/plain"
                    className="d-none"
                    onChange={(event) => uploadTextFile(event, setRobots, ".txt")}
                    disabled={loading || saving}
                  />
                </label>
              </div>
              <textarea
                className="form-control font-monospace"
                rows="18"
                value={robots}
                onChange={(event) => setRobots(event.target.value)}
                disabled={loading || saving}
                spellCheck="false"
              />
              <div className="form-text">{robots.length} characters</div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="bg-white p-3 rounded shadow-sm h-100">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <label className="form-label fw-semibold mb-0">sitemap.xml</label>
                <label className="btn btn-sm btn-outline-secondary mb-0">
                  Upload
                  <input
                    type="file"
                    accept=".xml,application/xml,text/xml"
                    className="d-none"
                    onChange={(event) => uploadTextFile(event, setSitemap, ".xml")}
                    disabled={loading || saving}
                  />
                </label>
              </div>
              <textarea
                className="form-control font-monospace"
                rows="18"
                value={sitemap}
                onChange={(event) => setSitemap(event.target.value)}
                disabled={loading || saving}
                spellCheck="false"
              />
              <div className="form-text">{sitemap.length} characters</div>
            </div>
          </div>
        </div>

        <div className="bg-white p-3 rounded shadow-sm mt-3">
          <h5 className="mb-3">Preview</h5>
          <div className="row g-3">
            <div className="col-lg-6">
              <p className="fw-semibold mb-2">/robots.txt</p>
              <pre className="border rounded bg-light p-3 mb-0" style={{ maxHeight: "260px", overflow: "auto", whiteSpace: "pre-wrap" }}>
                {robots || "No robots.txt content yet."}
              </pre>
            </div>
            <div className="col-lg-6">
              <p className="fw-semibold mb-2">/sitemap.xml</p>
              <pre className="border rounded bg-light p-3 mb-0" style={{ maxHeight: "260px", overflow: "auto", whiteSpace: "pre-wrap" }}>
                {sitemap || "No sitemap.xml content yet."}
              </pre>
            </div>
          </div>
        </div>

        <div className="mt-3">
          <button type="submit" className="btn btn-primary" disabled={loading || saving}>
            {saving ? "Saving..." : "Save SEO Files"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default function AdminDashboard() {
  const [active, setActive] = useState("add");
  const [checkingAuth, setCheckingAuth] = useState(true);
  const [authError, setAuthError] = useState("");

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/admin/auth_status.php`, {
          credentials: "include",
        });
        const rawText = await res.text();
        let data;
        try {
          data = JSON.parse(rawText);
        } catch {
          throw new Error("Invalid admin auth response.");
        }

        if (!res.ok || !data.authenticated) {
          window.location.href = "/admin/login";
          return;
        }
      } catch (err) {
        console.error("Admin auth check error:", err);
        setAuthError(err.message || "Unable to verify admin access.");
      } finally {
        setCheckingAuth(false);
      }
    };

    checkAuth();
  }, []);

  if (checkingAuth) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh", background: "#f3f4f6" }}>
        <div className="bg-white p-4 rounded shadow-sm">Checking admin access...</div>
      </div>
    );
  }

  if (authError) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh", background: "#f3f4f6" }}>
        <div className="alert alert-danger mb-0" role="alert">{authError}</div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f3f4f6" }}>
      <Sidebar active={active} onChange={setActive} />
      <div style={{ flex: 1, padding: "16px 24px" }}>
        {active === "add" && <AddBlog onCreated={() => setActive("view")} />}
        {active === "view" && <ViewBlogs />}
        {active === "seo" && <SeoManagement />}
        {active === "seoFiles" && <SeoFiles />}
        {active === "analytics" && <AnalyticsSettings />}
      </div>
    </div>
  );
}


